import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Planzone, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  updateTimesheetDeadline(
    request: Boundaries["editTimesheetDeadline"]["request"],
  ): void;
}

function useUpdateTimesheetDeadline(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUpdateTimesheetDeadlineRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUpdateTimesheetDeadlineRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUpdateTimesheetDeadlineRequestFailure(planzone),
    ),
    updateTimesheetDeadline: core.editTimesheetDeadline,
  };
}

export { useUpdateTimesheetDeadline };
